import Model, { ID, JsonArray, MODEL_LEVEL } from 'src/models/model'
import RegisterButton from 'src/models/register/RegisterButton'

const GRID_WIDTH = 5
const GRID_HEIGHT = 5
export default class RegisterGrid extends Model {
  static name = 'RegisterGrid'

  static isConfiguration = true

  static deletable = true
  static versioned = true
  static paginate = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.HardwareAndRegisterStation]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        default: null
      },
      registerButtons: {
        type: [RegisterButton],
        default () {
          return []
        }
      },
      libraryParentId: {
        type: ID,
        output: true,
        excludeFromDefault: true
      },
      receiveLibraryUpdates: {
        type: Boolean,
        excludeFromDefault: true
      },
      libraryChildSiteIds: {
        type: [ID],
        output: true,
        excludeFromDefault: true
      },
      libraryDescendantSites: {
        type: JsonArray,
        output: true,
        excludeFromDefault: true
      }
    }
  }

  get buttonArray () {
    const buttonArray = new Array(GRID_WIDTH * GRID_HEIGHT)

    _.each(this.registerButtons.data, (registerButton) => {
      buttonArray[registerButton.displayOrder] = registerButton
    })

    return buttonArray
  }

  get grid () {
    return _.chunk(this.buttonArray, GRID_WIDTH)
  }

  moveButton (buttonToMoveIndex, newLocationIndex) {
    const buttonToMove = this.buttonArray[buttonToMoveIndex]
    const newLocationButton = this.buttonArray[newLocationIndex]

    buttonToMove && (buttonToMove.displayOrder = newLocationIndex)
    newLocationButton && (newLocationButton.displayOrder = buttonToMoveIndex)
  }
}
